// navigate.js
let navigateFunction;
export const setNavigate = (nav) => { navigateFunction = nav; };
export const navigateTo = (path) => navigateFunction?.(path);